import { render, staticRenderFns } from "./CustomerOrderHistory.vue?vue&type=template&id=53f19523&"
import script from "./CustomerOrderHistory.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports